export function isSafe(params) {
  let isSafe = true;

  for (const property in params) {
    const value = params[property];
    if (
      typeof value === 'string' &&
      (value.includes('>') ||
        value.includes('<') ||
        value.includes(')') ||
        value.includes('(') ||
        value.includes('`'))
    ) {
      isSafe = false;
    }
  }

  return isSafe;
}
